(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('ResultsController', ResultsController);

    ResultsController.$inject = ['$scope', '$window', '$timeout', '$uibModal', '_', 'workflow', 'workspace', 'guard', 'pricingService',
        'userCartService', 'offlinePriceRequestService', 'multipleUploadTrackEventsService', 'eventService', 'uiService'];

    function ResultsController($scope, $window, $timeout, $uibModal, underscore, workflow, workspace, guard, pricingService,
        userCartService, offlinePriceRequestService, trackEventsService, eventService, uiService) {
        var vm = this;

        vm.isPostingToCart = false;
        vm.isPostingToOpr = false;
        vm.cartItemCreationSource = 2;

        vm.hasDiscount = hasDiscount;
        vm.getDiscount = getDiscount;
        vm.getSubtotal = getSubtotal;

        vm.areAllModelProcessed = areAllModelProcessed;
        vm.addProcessedModelsToCart = addProcessedModelsToCart;
        vm.requestPrices = requestPrices;
        vm.getProductOprs = getProductOprs;

        vm.removeAll = removeAll;

        // -----------------------------------------------------------------------------------

        function hasDiscount() {
            if (hasNotReadyProducts()) {
                return false;
            }

            return underscore.some(workspace.products, function (product) {
                return product.salesPrice && product.salesPrice.hasDiscount();
            });
        }

        function getDiscount() {
            var discount = 0;
            underscore.each(workspace.products, function (product) {
                if (!product.salesPrice) {
                    return;
                }

                var salesPrice = product.salesPrice;
                if (salesPrice.hasDiscount()) {
                    discount += salesPrice.price.amount - salesPrice.priceDiscounted.amount;
                }
            });

            return pricingService.formatPrice(discount * -1, workspace.settings.currency);
        }

        function getSubtotal() {
            if (hasNotReadyProducts()) {
                return pricingService.formatUnavailableMoney(undefined);
            }

            var subtotal = 0;
            underscore.each(workspace.products, function (product) {
                if (!product.salesPrice) {
                    return;
                }

                subtotal += product.salesPrice.priceDiscounted.amount;
            });

            return pricingService.formatPrice(subtotal, workspace.settings.currency);
        }

        function areAllModelProcessed() {
            var readyProducts = getReadyProducts();
            var successProducts = getSuccessProducts(readyProducts);

            return workspace.products.length === readyProducts.length && successProducts.length > 0;
        }

        function addProcessedModelsToCart() {
            var successProducts = getSuccessProducts();
            if (!successProducts || successProducts.length === 0) {
                return;
            }

            var request = createAddColdPrintLikeProductsRequest(successProducts);

            vm.isPostingToCart = true;
            resetGeneralError();

            userCartService.addColdPrintLikeProducts(request, false)
                .then(function () {
                    cancelProcessingForProducts(successProducts);
                    trackAddToCartEvent(successProducts);

                    $window.location.href = workspace.settings.cartPageUrl;
                })
                .catch(function () {
                    riseGeneralError();
                })
                .finally(function () {
                    vm.isPostingToCart = false;
                    uiService.scrollToTop();
                });
        }

        function requestPrices() {
            var oprs = getProductOprs();
            var request = _.map(oprs, function (product) {
                return createOfflinePriceRequestItem(product);
            });

            vm.isPostingToOpr = true;
            resetGeneralError();

            var oprWindow = $window.open(workspace.settings.oprPageUrl + "?l");

            offlinePriceRequestService.requestPrices(request)
                .then(function () {
                    cancelProcessingForProducts(oprs);
                    trackRequestPrice(oprs);

                    $timeout(function () {
                        oprWindow.location = workspace.settings.oprPageUrl;
                    });
                })
                .catch(function () {
                    riseGeneralError();
                })
                .finally(function () {
                    vm.isPostingToOpr = false;
                });
        }

        function getProductOprs() {
            return underscore.filter(getFailedProducts(), function (product) {
                return product.issue.isOpr();
            });
        }

        function removeAll() {
            showConfirmation()
                .then(removeAllProducts);
        }

        // ----------------------------------- Private functions -----------------------------

        function createAddColdPrintLikeProductsRequest(successProducts) {
            var productInfos = underscore.map(successProducts, function (product) {
                return {
                    productTemplateID: product.productTemplateId,
                    modelID: product.model.id,
                    materialID: product.material().id,
                    colourID: product.colour().id,
                    scale: product.scale(),
                    quantity: product.quantity()
                };
            });

            return {
                ProductInfos: productInfos,
                CartItemCreationSource: vm.cartItemCreationSource
            };
        }

        function createOfflinePriceRequestItem(product) {
            guard.argumentHasValue(product);

            return {
                modelId: product.model.id,
                materialId: product.material().id,
                colourId: product.colour().id,
                scale: product.scale(),
                quantity: product.quantity(),
                productTemplateId: product.productTemplateId
            };
        }

        function cancelProcessingForProducts(products) {
            underscore.each(products, function (product) {
                workflow.cancelProductProcessing(product.id);
            });
        }

        function getReadyProducts() {
            return underscore.filter(workspace.products, function (product) {
                return product.state === "Ready";
            });
        }

        function getSuccessProducts(products) {
            products = products || workspace.products;

            return underscore.filter(products, function (product) {
                return product.state === "Ready" && product.issue === null;
            });
        }

        function getFailedProducts(products) {
            products = products || workspace.products;

            return underscore.filter(products, function (product) {
                return product.state === "Ready" && product.issue !== null;
            });
        }

        function hasNotReadyProducts() {
            return underscore.some(workspace.products, function (product) {
                return product.state !== 'Ready';
            });
        }

        function trackAddToCartEvent(products) {
            try {
                trackEventsService.trackAddToCart(products);
            } catch (e) {
                console.error("trackAddToCart failed.", e);
            }
        }

        function trackRequestPrice(products) {
            try {
                trackEventsService.trackRequestPrice(products);
            } catch (e) {
                console.error("trackRequestPrice failed.", e);
            }
        }

        function riseGeneralError() {
            eventService.notify('generalError', 'ServerError');
        }

        function resetGeneralError() {
            eventService.notify("clearGeneralError");
        }

        function showConfirmation() {
            var modalWindow = $uibModal.open({
                templateUrl: '/Scripts/iMatApp/multipleUpload3DModel/views/removeAllConfirmationPopUp.html',
                controller: 'removeAllConfirmationController',
                controllerAs: 'confirmationViewModel'
            });

            return modalWindow.result;
        }

        function removeAllProducts() {
            workspace.products = [];
            uiService.scrollToTop();
        }
    }
})();